import { assert } from '@ember/debug';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import generatePositionFromTime from 'scaleflow/utils/generate-position-from-time';

export default class InitiativesUpdateWizardUncertaintiesComponent extends Component {
  @service store;
  @service currentUser;

  @tracked isShowingForm = false;

  @action
  createUncertainty() {
    const uncertainty = this.store.createRecord('uncertainty');
    uncertainty.author = this.currentUser.currentUser;
    uncertainty.assignees = [this.currentUser.currentUser];
    uncertainty.initiative = this.args.initiative;
    uncertainty.position = generatePositionFromTime();
    this.isShowingForm = true;
  }

  @action
  next() {
    if (!this.args?.next)
      assert('Pass a callback function to the "next" param');
    else this.args?.next();
  }

  @action
  back() {
    if (!this.args?.back)
      assert('Pass a callback function to the "back" param');
    else this.args?.back();
  }

  @action
  showNewButton() {
    this.isShowingForm = false;
  }
}
